
import moment from "moment"
import styled from "styled-components"

const Container = styled.div`
    width: 100%;
    padding: 30px 10px;
    background-color: ${({theme}) => theme.secondaryBgColor};
    border-radius: 20px;
    width: calc(100% - 60px);
    display: grid;
    grid-template-columns:1fr 1fr 1fr 1fr 1fr 1fr;
    gap: 15px;
    text-align: center;
    color: ${({theme}) => theme.mainTextColor};

    .data-item{
        color: ${({theme}) => theme.mainTextColor};
        display: flex;
        justify-content: center;

        .value{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
        }
    }
`

const FormSubmissionItem = ({item}) => {

  return (
    <Container>
        <div className="data-item">
            <span className="value">{item.companyName}</span>
        </div>
        <div className="data-item">
            <span className="value">{item.companyUserName}</span>
        </div>
        <div className="data-item">
            <span className="value">{item.mailAddress}</span>
        </div>
        <div className="data-item">
            <span className="value">{item.phoneNumber}</span>
        </div>
        <div className="data-item">
            <span className="value">{item.address}</span>
        </div>
        <div className="data-item">
            <span className="value">{moment(item?.createdAt)?.format('DD:MM:YYYY')}-{moment(item?.createdAt)?.format('HH:mm')}</span>
        </div>
    </Container>
  )
}

export default FormSubmissionItem